// extracted by mini-css-extract-plugin
module.exports = {"availableItem":"AvailableFilters_availableItem__1k6q8","type":"AvailableFilters_type__1_EzY"};